(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[747],{

/***/ 96379:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog_deprecated",
      function () {
        return __webpack_require__(39716);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 39716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var components_shared_HeadMetadata__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73412);
/* harmony import */ var hooks_useI18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39105);
/* harmony import */ var hooks_usePageTrack__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56002);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45847);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var utils_app_urls__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62177);
/* harmony import */ var utils_paths__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64516);
/* harmony import */ var _components_marketingSite_blog_BlogComponent__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58447);










var BlogPage = function(props) {
    var t = (0,hooks_useI18n__WEBPACK_IMPORTED_MODULE_2__/* .useI18n */ .Q)("blog").t;
    (0,hooks_usePageTrack__WEBPACK_IMPORTED_MODULE_3__/* .usePageTrack */ .N)("Blog - Page Loaded");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shared_HeadMetadata__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                title: t("pageTitle"),
                desc: t("pageDescription"),
                imgUrl: (0,utils_paths__WEBPACK_IMPORTED_MODULE_7__/* .getPublicPath */ .A)("/images/card_blog.png"),
                url: utils_app_urls__WEBPACK_IMPORTED_MODULE_5__/* .APP_URLS.blog */ .uu.blog,
                indexable: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_4___default()), {
                id: "blogMetadata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n            "@context": "https://schema.org",\n            "@type": "Blog",\n            "name": "'.concat(t("pageTitle"), '",\n            "url": "https://www.getmanfred.com/blog",\n            "description": "').concat(t("pageDescription"), '",\n            "publisher": {\n              "@type": "Organization",\n              "name": "Manfred",\n              "logo": {\n                "@type": "ImageObject",\n                "url": "https://media-asgard.s3.eu-west-1.amazonaws.com/manfred-media/logo_manfred_color.svg?v=38732000",\n                "width": 200,\n                "height": 50\n              }\n            }\n          }')
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_marketingSite_blog_BlogComponent__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, props), {
                currentPage: 0
            }))
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (BlogPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,625,4882,987,3576,9774,2888,179], function() { return __webpack_exec__(96379); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);